module.exports = __webpack_public_path__ + "static/media/banner1.c6d638df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/exeron/images/banner1.jpg
// module id = 506
// module chunks = 0